import { DocumentDownloadService } from '@xengage/gw-portals-document-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class ClaimDocumentService {
    static getClaimDocument(documentID, token) {
        return DocumentDownloadService.getDocumentLink(
            getProxiedServiceUrl('claimDownloadDocument'),
            documentID,
            token
        );
    }
}
